import Observer from 'common/scripts/observer';

const observer = new Observer();

class MapFilter {
    /**
     * Базовые свойства
     * @constructor
     */
    constructor() {
        this.buttons = null;
        this.globalFilterState = true;
        this.checkEvent = document.createEvent('HTMLEvents');
        this.checkEvent.initEvent('change', false, true);
    }

    /**
     * Инициализирует плагин
     * @param {Object} outerSettings - настройки из внешнего файла
     */
    init(outerSettings) {
        this.buttons = Array.from(outerSettings.target.querySelectorAll('.j-map-filter-item'));

        this._bindEvents();
    }

    /**
     * Навешивает обработчик клика
     */
    _bindEvents() {
        this.buttons.forEach((button) => {
            button.addEventListener('change', (event) => {
                const mapEvent = button.checked ? 'addFilterItem' : 'removeFilterItem';

                this._setGlobalFilterState();

                observer.publish(mapEvent, event.target.dataset.type);
                observer.publish('filterUpdated');
            });
        });
    }

    _setGlobalFilterState() {
        this.globalFilterState = this.buttons.every((button) => {
            return button.checked;
        });
    }

    changeCheckBoxState() {
        const holdGlobalFilterState = this.globalFilterState;

        this.buttons.forEach((button) => {
            if (button.checked !== holdGlobalFilterState) {
                return;
            }

            button.checked = !button.checked;
            button.dispatchEvent(this.checkEvent);
        });
    }
}

export default MapFilter;
